import { environment } from '../../../environments/environment';
import { ConditionTypeEnum } from '../enums/condition-type.enum';

export abstract class PagedRequest {
    pageIndex: number = 1;
    pageSize: number = environment.pageSizeDefault;
    conditionType: ConditionTypeEnum = ConditionTypeEnum.And;
}

export interface PagedResponse<T> {
    data: T[];
    pageIndex: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
}